import React from "react";
import classNames from "classnames";
import { css } from "@linaria/core";
import { color } from "@ui";
import Text from "@ui/Text";

const symptom = css`
  white-space: pre-wrap;

  &.symptomColor {
    color: ${color.raw.oxygen400};
  }
`;

interface P {
  description: string;
  isSymptom: boolean;
}

export const SymptomQuantityChartTooltip = ({ description, isSymptom }: P) => (
  <Text type="body1SemiBold" className={classNames(symptom, { symptomColor: isSymptom })}>
    {description}
  </Text>
);
